// Fix for Section Scroll

$(document).ready(function () {
    $('.shopify-section').each(function () {
        var section = $(this);
        section.find('a').each(function () {
            var link = $(this)
            var href = link.attr('href')
            if (href && href.indexOf('#') > -1) {
                link.on('click', function () {
                    var hash = href.split('#')[1]
                    var target = $('#' + hash)
                    if (target.length > 0) {
                        $('html, body').animate({
                            scrollTop: target.offset().top - 130
                        }, 500);
                    }
                })
            }
        })
    });

    // Automated fix for Iframe ADA Compliance

    if (window.location.pathname.includes("/products/")) {
        var iframes = document.querySelectorAll('iframe');
        iframes.forEach(function (iframe) {
            iframe.title = window.location.pathname.replace("/products/", "").replace(/-/g, " ");

        });
    }

    // Automated fix for Hidden video player controls on product cards with video playing on hover for ADA Compliance
    var videoWrapper = document.querySelectorAll('.plyr__video-wrapper');
    videoWrapper.forEach(function (wrapper) {
        var video = wrapper.querySelector('video');
        var img = video.querySelector('img');
        if (video && img) {
            var productCard = wrapper.closest('.product-thumbnail__link');
            var productTitle = productCard.querySelector('.product-thumbnail__title').textContent;
            img.alt = productTitle;
        }
    });
})

